import { tgxApi } from "../../../app/tgxApi";
import { getAuthorizationHeader, handleQueryError, handleQueryErrorAndSuccess } from "../../../helpers/utils/RtkQueryUtils";

export const rolesApi = tgxApi.injectEndpoints({
    endpoints: (build) => ({
        getRolesByCustomerId: build.query({
            query: (customerId) => {
                return {
                    url: `/ajax/role-by-customer-id/${customerId}`,
                    method: 'GET',
                    headers: getAuthorizationHeader()
                };
            },
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryError(queryFulfilled)
            },
        }),
        findAllRoles: build.query({
            query: () => {
                return {
                    url: `/ajax/all-roles`,
                    method: 'GET',
                    headers: getAuthorizationHeader()
                };
            },
            providesTags: ['roles'],
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryError(queryFulfilled)
            },
        }),

        createRole: build.mutation({
            query: (requestBody) => {
                return {
                    url: `/ajax/createRole`,
                    method: 'POST',
                    headers: getAuthorizationHeader(),
                    body: requestBody
                };
            },
            invalidatesTags: ['roles'],
            async onQueryStarted(_, { queryFulfilled }) {
                await handleQueryErrorAndSuccess(queryFulfilled, "Created", "Role");
            },
        }),
        getRoleById: build.query({
            query: (id) => {
                return {
                    url: `/ajax/get-role-by-id/${id}`,
                    method: 'GET',
                    headers: getAuthorizationHeader(),
                };
            },
            providesTags: ['roleById'],
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryError(queryFulfilled)
            },
        }),
        updateRole: build.mutation({
            query: ({ id, requestBody }) => {
                return {
                    url: `/ajax/updateRole`,
                    method: 'PUT',
                    headers: getAuthorizationHeader(),
                    body: requestBody
                };
            },
            invalidatesTags: ['roles', 'roleById', 'userAuditableInfo'],
            async onQueryStarted(_, { queryFulfilled }) {
                await handleQueryErrorAndSuccess(queryFulfilled, "Updated", "Role");
            }
        }),
        getAllPermissions: build.query({
            query: () => {
                return {
                    url: `/ajax/all-permissions`,
                    method: 'GET',
                    headers: getAuthorizationHeader(),
                };
            },
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryError(queryFulfilled)
            },
        }),
    })
});

export const {
    useGetRolesByCustomerIdQuery,
    useFindAllRolesQuery,
    useGetRoleByIdQuery,
    useCreateRoleMutation,
    useUpdateRoleMutation,
    useGetAllPermissionsQuery
} = rolesApi;